var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsDownloadWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27942",
    "data-name": "Group 27942",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.8,
    height: 22.524,
    viewBox: "0 0 23.8 22.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27941",
    "data-name": "Group 27941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16659",
    "data-name": "Path 16659",
    d: "M27.26,6.891,24.775,4,11.838,16.937,5.855,10.968,3.46,14.222l8.378,8.394Z",
    transform: "translate(-3.46 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7915",
    "data-name": "Rectangle 7915",
    width: 19.709,
    height: 2.816,
    transform: "translate(2 19.709)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsDownloadWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-download-whiteIcon.8bbe081a17b6c3bb28ce08a473f3e112.svg";
export { ForwardRef as ReactComponent };